import styles from "../add.module.css";
import { useState, useEffect } from "react";
import moment from "moment";

const Step4 = ({ bookingData, backToTab, saveStep4Data }) => {
    const [SubTotal, setSubTotal] = useState(0);
    const [Total, setTotal] = useState(0);
    const VATCharge = 0;
    const InsuranceCharge = 0;
    const [discountVal, setDiscountVal] = useState(0);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [referralDiscount, setReferralDiscount] = useState(0);
    const [subTotalNew, setSubTotalNew] = useState(0);
    const [productRDiscount, setProductRDiscount] = useState(0);
    const [pickupPhones, setPickupPhones] = useState([]);
    const [receipientPhones, setReceipientPhones] = useState([]);

    useEffect(() => {
        let subtotalTemp = 0;
        let discountTemp = 0;
        let discountTemp2 = 0;

        bookingData?.products?.forEach((item) => {
            subtotalTemp += parseFloat(item.total);
        });
        setSubTotal(subtotalTemp);

        setDiscountVal(bookingData?.discountVal);
        setDiscountAmount(bookingData?.discountAmount);
        setReferralDiscount(bookingData?.referralDiscount);

        if (bookingData?.discountAmount) {
            discountTemp = bookingData?.discountAmount;
        }

        if (bookingData?.referralDiscount) {
            discountTemp2 = bookingData?.referralDiscount;
        }

        // Membership-discounted subtotal, used as the base for spreading the referral
        // discount proportionally across each line item (mirrors admin booking flow).
        let subTotalNewTemp = (bookingData?.products || []).reduce((sum, item) => {
            if (parseFloat(bookingData?.discountVal) > 0) {
                let newDisc = ((parseFloat(item.total) * parseFloat(bookingData?.discountVal)) / 100);
                newDisc = Math.round(newDisc * 100) / 100;

                return sum + parseFloat(item.total) - newDisc;
            }
            return sum + parseFloat(item.total);
        }, 0);

        setSubTotalNew(subTotalNewTemp);

        setTotal(subtotalTemp + VATCharge + InsuranceCharge - discountTemp - discountTemp2);

        if (bookingData && bookingData?.pickUpData?.phone) {
            let pPhones = [];

            if (bookingData?.pickUpData?.alt_phones && bookingData?.pickUpData?.alt_phones?.length > 0) {
                pPhones = bookingData?.pickUpData?.alt_phones?.map(i => i?.value);
            }

            setPickupPhones([bookingData?.pickUpData?.phone].concat(pPhones));
        }

        if (bookingData && bookingData?.recipientData?.phone) {
            let rPhones = [];

            if (bookingData?.recipientData?.alt_phones && bookingData?.recipientData?.alt_phones?.length > 0) {
                rPhones = bookingData?.recipientData?.alt_phones?.map(i => i?.value);
            }

            setReceipientPhones([bookingData?.recipientData?.phone].concat(rPhones));
        }
    }, [bookingData]);

    useEffect(() => {
        if (bookingData?.referralDiscount) {
            if (parseFloat(bookingData?.referralDiscount) > 0 && subTotalNew > 0) {
                let refDiscP = parseFloat(bookingData?.referralDiscount) / parseFloat(subTotalNew);
                refDiscP = Math.round(refDiscP * 10000) / 10000;

                setProductRDiscount(refDiscP);
            }
        }
    }, [bookingData?.referralDiscount, subTotalNew]);

    return (<>
        <div className={`${styles.CustomWidth}`}>
            <p className={styles.SectionLabel}>Order summary</p>

            <div className={`${styles.SummerySec}`}>
                <div className={`${styles.SummerySecFull}`}>
                    <p>Freight Option: {bookingData?.freight_type || 'Sea Freight'}</p>
                </div>
                <div className={`${styles.SummerySecUnder}`}>
                    <div className={`${styles.SummerySecRow}`}>
                        <div className={`${styles.SummerySecHalf} ${styles.SummerySecHalf1}`}>
                            <p className={`${styles.StepBoxTitle2}`}>Sender details</p>
                            <ul className={`${styles.SummeryListSec}`}>
                                <li>
                                    <p className={`${styles.SummeryHeadTitle}`}>Name:</p>
                                    <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.name}</p>
                                </li>
                                <li>
                                    <p className={`${styles.SummeryHeadTitle}`}>Address:</p>
                                    <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.address}</p>
                                </li>
                                <li>
                                    <p className={`${styles.SummeryHeadTitle}`}>Post Code:</p>
                                    <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.post_code}</p>
                                </li>
                                <li>
                                    <p className={`${styles.SummeryHeadTitle}`}>Contact No:</p>
                                    <p className={`${styles.SummeryHeadText}`}>{pickupPhones.join(', ')}</p>
                                </li>
                            </ul>
                        </div>

                        <div className={`${styles.SummerySecHalf}  ${styles.SummerySecHalf2}`}>
                            <p className={`${styles.StepBoxTitle2}`}>Recipient details</p>
                            <ul className={`${styles.SummeryListSec}`}>
                                <li>
                                    <p className={`${styles.SummeryHeadTitle}`}>Name:</p>
                                    <p className={`${styles.SummeryHeadText}`}>{bookingData?.recipientData?.name}</p>
                                </li>
                                <li>
                                    <p className={`${styles.SummeryHeadTitle}`}>Address:</p>
                                    <p className={`${styles.SummeryHeadText}`}>{bookingData?.recipientData?.address}</p>
                                </li>
                                <li>
                                    <p className={`${styles.SummeryHeadTitle}`}>Contact No:</p>
                                    <p className={`${styles.SummeryHeadText}`}>{receipientPhones.join(', ')}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <p className={`${styles.StepBoxTitle}`}>Item details</p>
            <div className={`${styles.TableSec}`}>
                <table>
                    <tbody>
                        <tr>
                            <td className={`${styles.TableHead}`}>Pickup Item</td>
                            <td className={`${styles.TableHead}`}>Fragile</td>
                            <td className={`${styles.TableHead}`}>Estimated Value</td>
                        </tr>
                        {bookingData?.products?.map((item, idx) => {
                            let discTemp = 0;
                            let newTotal = parseFloat(item.total);

                            if (discountVal > 0) {
                                let discTemp1 = ((newTotal * discountVal) / 100);
                                discTemp1 = Math.round(discTemp1 * 100) / 100;

                                discTemp += discTemp1;
                                newTotal = newTotal - discTemp1;
                            }

                            if (productRDiscount > 0) {
                                let discTemp2 = (newTotal * productRDiscount);
                                discTemp2 = Math.round(discTemp2 * 100) / 100;

                                discTemp += discTemp2;
                            }

                            return (<tr key={idx}>
                                <td className={`${styles.TableCon}`}>
                                    {item?.item_name}
                                    {parseInt(item?.category_id) === -1 && <>
                                        <br />
                                        <span style={{ fontSize: '11px' }}>Dimension: <strong>L:{item?.length}</strong> <strong>W:{item?.width}</strong> <strong>H:{item?.height}</strong></span>
                                    </>}
                                    {bookingData?.freight_type === 'Air Freight' && item?.weight && <>
                                        <br />
                                        <span style={{ fontSize: '11px' }}>Weight: <strong>{item.weight} kg</strong></span>
                                    </>}
                                </td>
                                <td className={`${styles.TableCon}`}>{item?.is_fragile ? "Yes" : "No"}</td>
                                <td className={`${styles.TableCon}`}>
                                    &pound; {parseFloat(item.total).toFixed(2)}
                                    {discountVal > 0 && <>
                                        <br />
                                        <p style={{ fontSize: '12px' }}>(-&pound; {parseFloat(discTemp).toFixed(2)})</p>
                                    </>}
                                </td>
                            </tr>);
                        })}
                        <tr>
                            <td colSpan="2" className={`${styles.TableCon}`}>
                                <p className={`${styles.SummeryPPTI}`}>Order Subtotal:</p>
                                {discountVal > 0 && <p className={`${styles.SummeryPPTI}`}>Membership Discount({discountVal}%):</p>}
                                {referralDiscount > 0 && <p className={`${styles.SummeryPPTI}`}>Referral Discount:</p>}
                                <p className={`${styles.SummeryPPTI}`}>Total VAT:</p>
                                <p className={`${styles.SummeryPPTI}`}>Insurance Charges:</p>
                                <p className={`${styles.SummeryPPTI} ${styles.Big}`}>Total:</p>
                            </td>
                            <td className={`${styles.TableCon}`}>
                                <p className={`${styles.SummeryPPTE}`}>£{SubTotal.toFixed(2)}</p>
                                {discountVal > 0 && <p className={`${styles.SummeryPPTE}`}>-£{discountAmount.toFixed(2)}</p>}
                                {referralDiscount > 0 && <p className={`${styles.SummeryPPTE}`}>-£{referralDiscount.toFixed(2)}</p>}
                                <p className={`${styles.SummeryPPTE}`}>£{VATCharge.toFixed(2)}</p>
                                <p className={`${styles.SummeryPPTE}`}>£{InsuranceCharge.toFixed(2)}</p>
                                <p className={`${styles.SummeryPPTE} ${styles.Big}`}>£{Total.toFixed(2)}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className={`${styles.TableConSec}`}>
                <p className={`${styles.TableConSecTitle}`}>To be collected:</p>
                <p className={`${styles.TableConSecText}`}>{moment(bookingData.pickup_date).format("ddd MMM D, YYYY")}</p>
            </div>

            <div className={`${styles.TableConSec}`}>
                <p className={`${styles.TableConSecTitle}`}>Booking Notes:</p>
                <p className={`${styles.TableConSecText}`}>{bookingData?.notes}</p>
            </div>

            <div className={`${styles.StepBUSec}`}>
                <button type="button" onClick={backToTab} className={`${styles.Previous}`}>Back</button>
                <button type="button" onClick={saveStep4Data} className={`${styles.Next}`}>Next</button>
            </div>
        </div>
    </>);
}

export default Step4;